export enum PeremriGjinia {
  Mashkullore = 10,
  Femerore = 11,
}

export enum PermriGjinite {
  Mashkullore = 10,
  Femerore = 11,
  Asnjanese = 12,
}

export enum PeremriFormaFjales {
  cc = 10,
  s = 11
}

export enum PeremriLloji {
  Vetor = 10,
  Vetvetor = 11,
  Deftor = 12,
  Pronor = 13,
  Pyetes = 14,
  Lidhor = 15,
  Ipacaktuar = 16,
}

export enum PeremriNumri {
  Njejes = 10,
  Shumes = 11,
}

export enum PronoriLloji {
  IPaEmerzuar = 11,
  IEmerzuar = 10
}

export enum PeremriVeta {
  Epare = 10,
  Edyte = 11,
  Etrete = 12,
}

export enum PeremriRasa {
  Emerore = 10,
  Gjinore = 11,
  Dhanore = 12,
  Kallezore = 13,
  Rrjedhore = 14,
  Thirrore = 15,
  Vendore = 16,
}

export enum PeremrillojiParametri {
  VetaINjeejees = 10, //Veta I, njëjës
  VetaIShumees = 11, //Veta I, shumës
  VetaIINjeejees = 12, //Veta II, njëjës
  VetaIIShumees = 13, //Veta II, shumës
  VetaIIINjeejeesMashkullore = 14, //Veta III, njëjës, mashkullore
  VetaIIINjeejeesFemeeror = 15, //Veta III, njëjës, femëror
  VetaIIIShumeesMashkullore = 16, //Veta III, shumës, mashkullore
  VetaIIIShumeesFemeerore = 17, //Veta III, shumës femërore
  Rasee = 18, //Rasë
  MashkulloreIPanyjsheem = 19, //Mashkullore i panyjshëm
  FemeeroreIPanyjsheem = 20, //Femërore, i panyjshëm
  AsnjaneesIPanyjsheem = 21, //Asnjanës i panyjshëm
  MashkulloreINyjsheem = 22, //Mashkullore i nyjshëm
  FemeeroreINyjsheem = 23, //Femërore, i nyjshëm
  AsnjaneesINyjsheem = 24, //Asnjanës, i nyjshëm
  VetaIIINjeejeesAsnjanees = 25, //Veta III, njëjës, asnjanës
  PronoriVetvetorNjeejeesMashkullore = 26, //Pronori vetvetor, njëjës, mashkullore
  PronoriVetvetorNjeejeesFemeerore = 27, //Pronori vetvetor, njëjës, femërore
  PronoriVetvetorNjeejeesAsnjanees = 28, //Pronori vetvetor, njëjës, asnjanës
  PronoriVetvetorShumeesMashkullore = 29, //Pronori vetvetor, shumës, mashkullore
  PronoriVetvetorShumeesFemeerore = 30, //Pronori vetvetor, shumës, femërore
  Gjini = 31, //Gjini
  PaVeccori = 32, //Pa Veçori
  Mashkullore = 33, //Mashkullore
  Femeerore = 34, //Femërore
  Asnjanees = 35, //Asnjanës
  RaseeMashkullore = 36, //Rasë Mashkullore
  RaseeFemeerore = 37 //Rasë Femërore
}

export enum PeremriLloji10Parametri {
  VetaINjeejees = 10, //Veta I, njëjës
  VetaIShumees = 11, //Veta I, shumës
  VetaIINjeejees = 12, //Veta II, njëjës
  VetaIIShumees = 13, //Veta II, shumës
  VetaIIINjeejeesMashkullore = 14, //Veta III, njëjës, mashkullore
  VetaIIINjeejeesFemeeror = 15, //Veta III, njëjës, femëror
  VetaIIIShumeesMashkullore = 16, //Veta III, shumës, mashkullore
  VetaIIIShumeesFemeerore = 17, //Veta III, shumës femërore
}

export enum PeremriLloji11Parametri {
  Rasee = 18, //Rasë
}

export enum PeremriLloji12Parametri {
  MashkulloreIPanyjsheem = 19, //Mashkullore i panyjshëm
  FemeeroreIPanyjsheem = 20, //Femërore, i panyjshëm
  AsnjaneesIPanyjsheem = 21, //Asnjanës i panyjshëm
  MashkulloreINyjsheem = 22, //Mashkullore i nyjshëm
  FemeeroreINyjsheem = 23, //Femërore, i nyjshëm
  AsnjaneesINyjsheem = 24, //Asnjanës, i nyjshëm
}

export enum PeremriLloji13Parametri {
  VetaINjeejees = 10, //Veta I, njëjës
  VetaIShumees = 11, //Veta I, shumës
  VetaIINjeejees = 12, //Veta II, njëjës
  VetaIIShumees = 13, //Veta II, shumës
  VetaIIINjeejeesMashkullore = 14, //Veta III, njëjës, mashkullore
  VetaIIINjeejeesFemeeror = 15, //Veta III, njëjës, femëror
  VetaIIINjeejeesAsnjanees = 25, //Veta III, njëjës, asnjanës
  PronoriVetvetorNjeejeesMashkullore = 26, //Pronori vetvetor, njëjës, mashkullore
  PronoriVetvetorNjeejeesFemeerore = 27, //Pronori vetvetor, njëjës, femërore
  PronoriVetvetorNjeejeesAsnjanees = 28, //Pronori vetvetor, njëjës, asnjanës
  VetaIIIShumeesMashkullore = 16, //Veta III, shumës, mashkullore
  VetaIIIShumeesFemeerore = 17, //Veta III, shumës femërore
  PronoriVetvetorShumeesMashkullore = 29, //Pronori vetvetor, shumës, mashkullore
  PronoriVetvetorShumeesFemeerore = 30, //Pronori vetvetor, shumës, femërore
}

export enum PeremriLloji14Parametri {
  MashkulloreIPanyjsheem = 19, //Mashkullore i panyjshëm
  FemeeroreIPanyjsheem = 20, //Femërore, i panyjshëm
  AsnjaneesIPanyjsheem = 21, //Asnjanës i panyjshëm
  MashkulloreINyjsheem = 22, //Mashkullore i nyjshëm
  FemeeroreINyjsheem = 23, //Femërore, i nyjshëm
  AsnjaneesINyjsheem = 24, //Asnjanës, i nyjshëm
  Rasee = 18, //Rasë
  Gjini = 31, //Gjini
  PaVeccori = 32, //Pa Veçori
}

export enum PeremriLloji15Parametri {
  MashkulloreINyjsheem = 22, //Mashkullore i nyjshëm
  FemeeroreINyjsheem = 23, //Femërore, i nyjshëm
  AsnjaneesINyjsheem = 24, //Asnjanës, i nyjshëm
  MashkulloreIPanyjsheem = 19, //Mashkullore i panyjshëm
  FemeeroreIPanyjsheem = 20, //Femërore, i panyjshëm
  AsnjaneesIPanyjsheem = 21, //Asnjanës i panyjshëm
  Rasee = 18, //Rasë
  PaVeccori = 32, //Pa Veçori
}

export enum PeremriLloji16Parametri {
  Mashkullore = 33, //Mashkullore
  Femeerore = 34, //Femërore
  Asnjanees = 35, //Asnjanës
  Rasee = 18, //Rasë
  RaseeMashkullore = 36, //Rasë Mashkullore
  RaseeFemeerore = 37, //Rasë Femërore
  PaVeccori = 32, //Pa Veçori
}

export enum PeremriRenditja {
  EmerPeremerdeftor = 10,
  PeremerdeftorEmer = 11,
}

export enum PeremriTrajta {
  Eshquar = 10,
  Epashquar = 11,
}

export enum PeremriTrajtatEShkurtraTeBashkuaraKolonat {
  DhanoreINjejesKallezoreIIINjejes = 10,
  DhanoreIINjejesKallezoreIIINjejes = 11,
  DhanoreIIINjejesKallezoreIIINjejes = 12,
  DhanoreIShumesKallezoreIIINjejes = 13,
  DhanoreIIShumesKallezoreIIINjejes = 14,
  DhanoreIIIShumesKallezoreIIINjejes = 15,
  DhanoreINjejesKallezoreIIIShumes = 16,
  DhanoreIINjejesKallezoreIIIShumes = 17,
  DhanoreIIINjejesKallezoreIIIShumes = 18,
  DhanoreIShumesKallezoreIIIShumes = 19,
  DhanoreIIShumesKallezoreIIIShumes = 20,
  DhanoreIIIShumesKallezoreIIIShumes = 21,
  DhanoreIIIMashkulloreNjejesKallezoreIIINjejes = 22,
  DhanoreIIIFemeroreNjejesKallezoreIIINjejes = 23,
  DhanoreIIIMashkulloreShumesKallezoreIIINjejes = 24,
  DhanoreIIIFemeroreShumesKallezoreIIINjejes = 25,
  DhanoreIIIMashkulloreNjejesKallezoreIIIShumes = 26,
  DhanoreIIIFemeroreNjejesKallezoreIIIShumes = 27,
  DhanoreIIIMashkulloreShumesKallezoreIIIShumes = 28,
  DhanoreIIIFemeroreShumesKallezoreIIIShumes = 29,
}
